const base = {
    get() {
        return {
            url : "http://localhost:8080/springboot3mpcs325/",
            name: "springboot3mpcs325",
            // 退出到首页链接
            indexUrl: 'http://localhost:8080/springboot3mpcs325/front/dist/index.html'
        };
    },
    getProjectName(){
        return {
            projectName: "线上茶叶交易平台"
        } 
    }
}
export default base
